import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";

interface MxDetailLabelValueProps {
  label: string;
  value: string;
  direction?: "column" | "row";
}

const MxDetailLabelValue = ({
  label,
  value,
  direction
}: MxDetailLabelValueProps) => {
  return (
    <Grid
      container
      item
      xs={12}
      alignItems={direction === "row" ? "center" : "flex-start"}
      gap={1}
      flexDirection={direction}
    >
      <MxTypography
        dangerouslySetInnerHTML={{ __html: label }}
        variant="subtitle2"
        color="primary.main"
      />
      <MxTypography
        dangerouslySetInnerHTML={{ __html: value }}
        variant="caption"
        color="grey.600"
        textTransform="capitalize"
      />
    </Grid>
  );
};

export default MxDetailLabelValue;
